import React from 'react';
import styled from 'styled-components';
import { Container } from '../../../view/Containers';
import { HeaderWithSeparator } from '../../../view/TextSubHeaders';
import { Paragraph } from '../../../view/Paragraph';
import { HorizontalCard, HorizontalCardInnerWrapper } from '../../../view/HorizontalCard';
import website from '../../../img/ContactUs/website.png';
import shop from '../../../img/ContactUs/shop.png';
import { BasicRoundedLink } from '../../../view/Buttons';
import { Margin } from '../../../view/Margin';

const SectionContactContainer = styled(Container)`
  padding: 30px 55px 17px 55px;
`;

const Flex = styled.section`
display: flex;
@media screen and (max-width: 1200px) {
    display: block;
  }
`;

const SectionContactBoxesWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media screen and (max-width: 1200px) {
    display: block;
  }
`;

const ContactBox = styled.article`
  width: 100%;
  max-width: 273px;
  @media screen and (max-width: 1200px) {
    max-width: 100%;
  }
`;

export const ContactSectionBody = (): JSX.Element => (
  <>
    <SectionContactContainer inColor>
      <SectionContactBoxesWrapper>
        <ContactBox>
          <HeaderWithSeparator as="h2" header="Owocowo" upperSubHeader="Dane" />
          <Paragraph>
            <>
              Gospodarstwo Ogrodnicze Owocowo
              <br />
              Paulina Chruślińska
              <br />
              Kosuty 94A, 21-421 Tuchowicz, Polska
              <br />
              NIP: 8252043579
              <br />
              BDO000202803
              <br />
              <b>506 165 383</b>
              <br />
              <b>owocowo@owocowo.com.pl</b>
              <br />
            </>
          </Paragraph>
        </ContactBox>
        <ContactBox>
          <HeaderWithSeparator as="h2" header="Justyna" upperSubHeader="Marketing" />
          <Paragraph>
            <>
              <b>515 560 815</b>
              <br />
              <b>marketing@owocowo.com.pl</b>
              <br />
            </>
          </Paragraph>
        </ContactBox>
        <ContactBox>
          <HeaderWithSeparator as="h2" header="Paulina" upperSubHeader="Współpraca" />
          <Paragraph>
            <>
              <b>506 165 383</b>
              <br />
              <b>paulina@owocowo.com.pl</b>
              <br />
            </>
          </Paragraph>
        </ContactBox>
      </SectionContactBoxesWrapper>
    </SectionContactContainer>
    <Container>
      <Flex>
        <HorizontalCard url={shop} />
        <HorizontalCard>
          <HorizontalCardInnerWrapper>
            <HeaderWithSeparator as="h2" header=" OWCA Showroom FOOD" upperSubHeader="Gdzie kupić?" />
            <Paragraph>
              <>
                Nasze produkty zakupisz w zaprzyjazionym stoisku na Mokowtowie w Warszawie.
                Owca showroom
                food znajduje się na ul. Kłobuckiej 8c/u3. Sprawdź godziny otwarcia.
              </>
            </Paragraph>
            <Margin height={25} />
            <BasicRoundedLink href="https://goo.gl/maps/be6RDy5pg3DLVH6SA" rel="noreferrer noopener nofollow" target="_blank">
              Kontakt
            </BasicRoundedLink>
          </HorizontalCardInnerWrapper>
        </HorizontalCard>
      </Flex>
      <Flex>
        <HorizontalCard>
          <HorizontalCardInnerWrapper>
            <HeaderWithSeparator as="h2" header="Sklep Internetowy" upperSubHeader="Gdzie kupić?" />
            <Paragraph>
              Wększość naszego asortymentu możesz zamówić przez sklep internetowy.
              Syropy, soki, dżemy, kiszonki,
              oleje, ale też świeże mleko i warzywa - wszytko to przygotujemy zgodnie
              ze złożonym przez Ciebie zamówieniem i wyślemy pod wskazany adres
            </Paragraph>
            <Margin height={25} />
            <BasicRoundedLink href="https://www.sklep.owocowo.com.pl/">
              Odkrywaj
            </BasicRoundedLink>
          </HorizontalCardInnerWrapper>
        </HorizontalCard>
        <HorizontalCard url={website} />
      </Flex>
    </Container>
  </>
);
